import "./projects.css";
import { FaGithub } from "react-icons/fa";
import { HiExternalLink } from "react-icons/hi";


function Projects () {
  const openLink = (url) => {
    window.open(url);
  };
  return (
      <div className="projects-projects" id="projects">
          <div class="text-divider-project"></div>
          <h1 className="projects-heading">My Projects</h1>
          <div className="projects-container">
              {/* {data.projects.map((elm) => {
          return <ProjectSet key={elm.id} {...elm} />;
        })} */}

              <div className="project-card">
                  <div className="project-card-container">
                      <div className="project-img">
                          <img
                              src={
                                  process.env.PUBLIC_URL +
                                  "./Images/DecorDash.png"
                              }
                              alt=""
                          />
                      </div>
                      <div className="project-card-text">
                          <h1 className="project-title">Decor Dash</h1>
                          <p className="project-description">
                              This is an e-commerce website for furniture where
                              users can purchase different types of furniture,
                              filter products by category and price, add items
                              to the cart, and checkout. Users can also view
                              their order history and track.
                          </p>
                          <div className="project-tech-stack">
                              <div
                                  key={Date.now() + Math.random()}
                                  className="project-skills-card">
                                  <img
                                      src="https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      HTML
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://www.vectorlogo.zone/logos/w3_css/w3_css-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      CSS
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://cdn-icons-png.flaticon.com/512/5968/5968292.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      JavaScript
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      React Js
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://lh5.googleusercontent.com/fIY8_nCkUbVDqzQA_RNU_H7u6X3hKQB9hm89AoK_6R4s3nGcUqLiK5UEJaNBlOksqVI=w2400"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      Redux
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://img.icons8.com/color/256/chakra-ui.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      Chakra UI
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://avatars.githubusercontent.com/u/79146003?s=200&v=4"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      Mantine UI
                                  </p>
                              </div>

                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://cdn-icons-png.flaticon.com/512/5968/5968322.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      Node JS
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://www.vectorlogo.zone/logos/expressjs/expressjs-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      Express JS
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      MongoDB
                                  </p>
                              </div>
                          </div>
                          <div className="project-card-btn">
                              <div
                                  onClick={() =>
                                      openLink(
                                          `https://github.com/RitikSingh11661/noble-weather-6049`
                                      )
                                  }
                                  className="project-github-link">
                                  GitHub <FaGithub />
                              </div>
                              <div
                                  onClick={() =>
                                      openLink(`https://decordash.vercel.app/`)
                                  }
                                  className="project-deployed-link">
                                  Deploy <HiExternalLink />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="project-card">
                  <div className="project-card-container">
                      <div className="project-img">
                          <img
                              src={
                                  process.env.PUBLIC_URL + "./Images/nykka.png"
                              }
                              alt=""
                          />
                      </div>
                      <div className="project-card-text">
                          <h1 className="project-title">Glam Up</h1>
                          <p className="project-description">
                              Glamup is an e-commerce website that is similar to
                              Nykaa and offers a wide range of beauty, wellness,
                              and fashion products for women. The website offers
                              a variety of products including makeup, skincare,
                              haircare, fragrances, personal care, and fashion
                              accessories.
                          </p>
                          <div className="project-tech-stack">
                              <div
                                  key={Date.now() + Math.random()}
                                  className="project-skills-card">
                                  <img
                                      src="https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      HTML
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://www.vectorlogo.zone/logos/w3_css/w3_css-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      CSS
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://cdn-icons-png.flaticon.com/512/5968/5968292.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      JavaScript
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      React Js
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://lh5.googleusercontent.com/fIY8_nCkUbVDqzQA_RNU_H7u6X3hKQB9hm89AoK_6R4s3nGcUqLiK5UEJaNBlOksqVI=w2400"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      Redux
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://cdn-icons-png.flaticon.com/512/136/136525.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      JSON
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://img.icons8.com/color/256/chakra-ui.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      Chakra UI
                                  </p>
                              </div>
                          </div>
                          <div className="project-card-btn">
                              <div
                                  onClick={() =>
                                      openLink(
                                          `https://github.com/KaustubhN12/nappy-prose-7608`
                                      )
                                  }
                                  className="project-github-link">
                                  GitHub <FaGithub />
                              </div>
                              <div
                                  onClick={() =>
                                      openLink(`https://glam-up.vercel.app/`)
                                  }
                                  className="project-deployed-link">
                                  Deploy <HiExternalLink />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="project-card">
                  <div className="project-card-container">
                      <div className="project-img">
                          <img
                              src={
                                  process.env.PUBLIC_URL +
                                  "./Images/camlens.png"
                              }
                              alt=""
                          />
                      </div>
                      <div className="project-card-text">
                          <h1 className="project-title">CamLens</h1>
                          <p className="project-description">
                              CamLens is an online retail website for
                              photography products. Its provide a variety of
                              photo, videoand audio equipment, computers, home
                              entertainment products, and much more.
                          </p>
                          <div className="project-tech-stack">
                              <div
                                  key={Date.now() + Math.random()}
                                  className="project-skills-card">
                                  <img
                                      src="https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      HTML
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://www.vectorlogo.zone/logos/w3_css/w3_css-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      CSS
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://cdn-icons-png.flaticon.com/512/5968/5968292.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      JavaScript
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      React Js
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://camo.githubusercontent.com/48d099290b4cb2d7937bcd96e8497cf1845b54a810a6432c70cf944b60b40c77/68747470733a2f2f7261776769742e636f6d2f676f72616e67616a69632f72656163742d69636f6e732f6d61737465722f72656163742d69636f6e732e737667"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      React Icons
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://cdn-icons-png.flaticon.com/512/136/136525.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      JSON
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://img.icons8.com/color/256/chakra-ui.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      Chakra UI
                                  </p>
                              </div>
                          </div>
                          <div className="project-card-btn">
                              <div
                                  onClick={() =>
                                      openLink(
                                          `https://github.com/riyashri07/makeshift-top-3565`
                                      )
                                  }
                                  className="project-github-link">
                                  GitHub <FaGithub />
                              </div>
                              <div
                                  onClick={() =>
                                      openLink(
                                          `https://myprojectrct101-camlens.netlify.app/`
                                      )
                                  }
                                  className="project-deployed-link">
                                  Deploy <HiExternalLink />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="project-card">
                  <div className="project-card-container">
                      <div className="project-img">
                          <img
                              src={
                                  process.env.PUBLIC_URL +
                                  "./Images/surveymonkey.png"
                              }
                              alt=""
                          />
                      </div>
                      <div className="project-card-text">
                          <h1 className="project-title">SurveyHomes</h1>
                          <p className="project-description">
                              SurveyMonkey is a website that provides a platform
                              for conducting online surveys. It allows
                              individuals,businesses, and organizations to
                              create custom surveys to gather feedback,
                              opinions, and data from a targeted audience
                          </p>
                          <div className="project-tech-stack">
                              <div
                                  key={Date.now() + Math.random()}
                                  className="project-skills-card">
                                  <img
                                      src="https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      HTML
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://www.vectorlogo.zone/logos/w3_css/w3_css-icon.svg"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      CSS
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://cdn-icons-png.flaticon.com/512/5968/5968292.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      JavaScript
                                  </p>
                              </div>
                              <div
                                  className="project-skills-card"
                                  key={Date.now() + Math.random()}>
                                  <img
                                      src="https://cdn-icons-png.flaticon.com/512/136/136525.png"
                                      alt=""
                                      className="project-skills-card-img"
                                  />
                                  <p className="project-skills-card-name">
                                      JSON
                                  </p>
                              </div>
                          </div>
                          <div className="project-card-btn">
                              <div
                                  onClick={() =>
                                      openLink(
                                          `https://github.com/riyashri07/simple-tank-2275/tree/main`
                                      )
                                  }
                                  className="project-github-link">
                                  GitHub <FaGithub />
                              </div>
                              <div
                                  onClick={() =>
                                      openLink(
                                          `https://steady-choux-5544ac.netlify.app/`
                                      )
                                  }
                                  className="project-deployed-link">
                                  Deploy <HiExternalLink />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
}

export default Projects;
